import { createContext } from 'react'
import type { createReportNavigationState } from '@/lib/reports/navigation-state'

export const ReportNavigationContext = createContext<ReturnType<typeof createReportNavigationState> | null>(null)
